import { Alert, AlertDescription } from "../components/ui/alert";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { AnimatedPage, FadeIn } from "../components/AnimatedPage";
import { useOps } from "../hooks/useOps";
import { useFaq } from "../features/faq/hooks/useFaq";
import { FaqSelector } from "../features/faq/components/faq-selector";
import { FaqList } from "../features/faq/components/faq-list";

export function Home() {
  const { currentOps } = useOps();
  const { selectedOps, options, currentFaqItems, handleSelectOps } = useFaq();

  if (!currentOps) {
    return (
      <AnimatedPage className="w-full p-6">
        <Alert>
          <AlertDescription>
            Selecione uma operação para acessar o sistema.
          </AlertDescription>
        </Alert>
      </AnimatedPage>
    );
  }

  return (
    <AnimatedPage className="w-full p-6 space-y-6">
      <FadeIn>
        <div>
          <h1 className="text-3xl font-bold">FAQ - Perguntas Frequentes</h1>
          <p className="text-muted-foreground">
            Encontre respostas para as principais dúvidas sobre operações
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.1}>
        <Card>
          <CardHeader>
            <CardTitle>Dúvidas Frequentes</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <FaqSelector
              selectedOps={selectedOps}
              onSelectOps={handleSelectOps}
              options={options}
            />
            <FaqList items={currentFaqItems} />
          </CardContent>
        </Card>
      </FadeIn>
    </AnimatedPage>
  );
}
